
const SeatGrid = ({
  selectedSection,
  activeSeatSlot,
  newSeatLabel,
  setNewSeatLabel,
  newSeatType,
  setNewSeatType,
  handleSeatNameSubmit,
  handleDeleteSeat,
  handleEmptySlotClick,
  seatLabelInputRef,
  selectedSeatId,
  setSelectedSeatId,
  setBookingForm,
  onEditSeat, // New prop
  mode,
}) => {
  // Seat layout is now driven by per-section seat_dimensions from the API
  const selectedSectionSeatColumns = selectedSection.seatColumns || 6;
  const selectedSectionSeatRows = selectedSection.seatRows || 2;
  const selectedSectionSeatLimit = selectedSectionSeatColumns * selectedSectionSeatRows;

  return (
    <div className=" border border-slate-200 bg-slate-50 p-8 ">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-xl font-medium text-slate-950">Seats</h3>
          <p className="mt-1 text-xs font-medium text-slate-400">
            {mode === "seats"
              ? "Click empty slots to add seats. Click an existing seat to manage or delete."
              : "Select an active seat to book or view current occupancy status."}
          </p>
        </div>
        <div className="rounded-full bg-white px-4 py-1.5 text-xs font-black text-indigo-600 shadow-sm border border-slate-100">
          {selectedSection.seats.length} / {selectedSectionSeatLimit}
        </div>
      </div>

      <div
        className="mt-8 grid gap-4"
        style={{
          gridTemplateColumns: `repeat(${selectedSectionSeatColumns}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({
          length: selectedSectionSeatColumns * selectedSectionSeatRows,
        }).map((_, index) => {
          const row = Math.floor(index / selectedSectionSeatColumns) + 1;
          const column = (index % selectedSectionSeatColumns) + 1;
          const seat = selectedSection.seats.find(
            (item) => item.row === row && item.column === column
          );
          const isNamingThis =
            activeSeatSlot?.row === row && activeSeatSlot?.column === column;
          const isSelected = selectedSeatId === seat?.id;

          // ── Add-seat form ──────────────────────────────────────────────
          if (isNamingThis) {
            return (
              <div
                key={`${row}-${column}`}
                className="min-h-[100px] border-2 border-slate-900 bg-white p-2.5 shadow-xl z-10 flex flex-col justify-center"
              >
                <form onSubmit={handleSeatNameSubmit} className="flex flex-col gap-1 h-full justify-between">
                  <input
                    ref={seatLabelInputRef}
                    value={newSeatLabel}
                    onChange={(e) => setNewSeatLabel(e.target.value)}
                    placeholder="e.g. S-01"
                    className="w-full rounded-lg border border-slate-200 px-2 py-0.5 text-xs font-bold outline-none focus:ring-2 focus:ring-slate-900/10"
                  />
                  <select
                    value={newSeatType}
                    onChange={(e) => setNewSeatType(e.target.value)}
                    className="w-full rounded-lg border border-slate-200 bg-slate-50 px-2 py-0.5 text-[9px] font-black uppercase outline-none"
                  >
                    <option value="laptop">Laptop</option>
                    <option value="monitor">Monitor</option>
                    <option value="desktop">Desktop</option>
                  </select>
                  <button
                    type="submit"
                    className="w-full rounded-lg bg-slate-900 py-0.5 text-xs font-bold text-white hover:bg-slate-700 transition-colors"
                  >
                    Add
                  </button>
                </form>
              </div>
            );
          }

          // ── Existing seat card ─────────────────────────────────────────
          if (seat) {
            return (
              <div
                key={`${row}-${column}`}
                className={`min-h-[100px] border-[1px] p-4 transition-all duration-200 relative group flex items-center ${
                  isSelected
                    ? "border-slate-900 bg-white shadow-lg z-10"
                    : "border-slate-200 bg-white hover:border-slate-200 hover:shadow-sm"
                }`}
              >
                <button
                  type="button"
                  onClick={() => {
                    setSelectedSeatId(seat.id);
                    setBookingForm?.((prev) => ({ ...prev, seatId: seat.id }));
                  }}
                  className="w-full text-left flex flex-col gap-1.5"
                >
                  <p className="text-sm font-medium text-slate-950 pr-4">
                    {seat.label}
                  </p>
                  <span className="inline-block self-start rounded-md bg-slate-100 px-2 py-0.5 text-[9px] font-black tracking-widest uppercase text-slate-500">
                    {seat.type}
                  </span>
                </button>
              </div>
            );
          }


          // ── Empty slot ─────────────────────────────────────────────────
          if (mode === "bookings") {
            return (
              <div
                key={`${row}-${column}`}
                className="min-h-[100px] border-2 border-dashed border-slate-100 bg-slate-50/20 p-4 text-[10px] font-black uppercase tracking-widest text-slate-300/40 flex items-center justify-center select-none"
              >
                Empty
              </div>
            );
          }

          return (
            <button
              key={`${row}-${column}`}
              type="button"
              onClick={() => handleEmptySlotClick(row, column)}
              className="min-h-[100px] border-[1px] border-dashed border-slate-300 bg-white/50 p-4 text-[10px] font-black uppercase tracking-widest text-slate-400 transition-all hover:bg-white hover:border-slate-300 hover:text-slate-500 hover:shadow-sm flex items-center justify-center"
            >
              + Add
            </button>
          );
        })}
      </div>
    </div>
  );
};


export default SeatGrid;

